/**
 * Console log only if in development environment.
 */
export function debug() {
  /* eslint-disable-next-line no-console */
  console.log(...arguments)
}
